<template>
  <form class="dashboard-block">
    <h2>Contract Type</h2>
    <div class="panel panel-grey">
      <div class="panel-body">
        <div>
          <selectize
            class="selectize selectize-single"
            name="contract"
            v-model="stateFirstContractId"
            :options="contractOptions">
          </selectize>
          <div class="spacer-y-2" v-if="activeContract && !contractChanged">
            <label class="control-label">{{ activeContract.name }}</label>
            <p>{{ activeContract.description }}</p>
            <p>Since: {{ activeContract.startDate | date }}</p>
            <p>Reset: {{ activeContract.endDate | date }}</p>
            <div v-if="user.contracts && user.contracts.length && user.contracts[0].user_requirement_values.length">
              <h3>Requirements</h3>
              <span v-for="requirement in user.contracts[0].user_requirement_values" :key="requirement.id">
                {{ requirement.name }}: {{ requirement.value }}{{ requirement.requirement_value ? '/' + requirement.requirement_value : ''}}<br/>
              </span>
            </div>
          </div>
          <div class="spacer-y-2" v-else-if="contractChanged">
            <p>
              The contract has changed. Please 'save' to update the information.
            </p>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <ladda-button
          type="submit"
          class="btn btn-sm btn-primary"
          :click="handleSaveContract"
          :disabled="userIsAdmin && !canEditAdmin">
          Save
        </ladda-button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { stateMapper, helpers } from 'mixins/users'
import { handleServerErrors, notify } from 'utils'
import Selectize from '../ext/codium/CodiumSelectize'

export default {
  mixins: [stateMapper, helpers],
  components: {
    Selectize
  },
  data () {
    return {
      contractOptions: [],
      initialContractId: null
    }
  },
  created () {
  },
  computed: {
    ...mapState('user', ['user']),
    activeContract () {
      return this.contractOptions.find(element => element.id === this.stateFirstContractId)
    },
    contractChanged () {
      return this.stateFirstContractId !== this.initialContractId
    }
  },
  mounted () {
    this.getContracts().then(response => {
      this.contractOptions = response.data.map(item => {
        return {
          text: item.name,
          ...item
        }
      })
      this.initialContractId = this.stateFirstContractId
    })
  },
  methods: {
    ...mapActions('user', ['updateUser', 'setUserProperty']),
    ...mapActions('contract', ['getContracts']),
    handleSaveContract () {
      return this.updateUser({
        id: this.user.id,
        payload: {
          contract_id: this.stateFirstContractId
        }
      })
        .then(response => {
          this.setUserProperty({ property: 'contracts', value: response.data.contracts })
          this.initialContractId = this.stateFirstContractId
          notify.success('Successfully set user contract')
        })
        .catch((error) => {
          if (error.response) {
            handleServerErrors(error, this.errors)
          } else {
            notify.error('Sorry something has gone wrong, please try again.')
            throw error
          }
        })
    }
  }
}
</script>
